import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57dea0cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ss-tela-conteudo-completo" }
const _hoisted_3 = {
  key: 0,
  class: "ant-row ss-div-titulo mobile"
}
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"width":"100%"} }, "Seja bem vindo!", -1))
const _hoisted_6 = {
  key: 1,
  class: "ant-row ss-div-titulo"
}
const _hoisted_7 = { class: "ant-row ss-div-corpo" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-utilidades" }
const _hoisted_9 = { class: "ss-div-noticias" }
const _hoisted_10 = { class: "ss-div-tarefas" }
const _hoisted_11 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-18 ss-div-widgets"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_noticias = _resolveComponent("noticias")!
  const _component_minhas_tarefas = _resolveComponent("minhas-tarefas")!
  const _component_widgets_usuario = _resolveComponent("widgets-usuario")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.storeSistema.state.layoutMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, "Olá " + _toDisplayString(_ctx.state.nomeUsuario), 1),
            _hoisted_5
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", null, "Olá " + _toDisplayString(_ctx.state.nomeUsuario) + ", Seja bem vindo!", 1)
          ])),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_noticias)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_minhas_tarefas)
          ])
        ]),
        (!_ctx.storeSistema.state.layoutMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_widgets_usuario)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}